import { shape, string } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { withDocumentTitle } from '../../generic/DocumentTitle';
import Titled from '../../layout/Titled';
import api from '../../REST/api';
import DeleteButton from '../../REST/DeleteButton';
import update from '../../REST/update';
import { tapFlashSuccess } from '../../utils/flash';
import AgreementForm from '../AgreementForm';
import {
  getTransformedAgreement,
  transformForPatch,
} from '../transform-agreement-helpers';

const UpdateAgreementForm = update({
  query: getTransformedAgreement,
  deriveQueryArgs: ({ id }) => ({ id }),
  update: ({ id }, changedModel) =>
    api
      .patchAgreement({
        id,
        data: transformForPatch(changedModel),
      })
      .then(tapFlashSuccess('Agreement updated')),
  form: withDocumentTitle(({ model }) => model.name)(AgreementForm),
  redirectTo: '/agreements/:id/show',
});

const UpdateAgreement = ({ match }) => {
  const id = Number.parseInt(match.params.id, 10);

  return (
    <Titled
      title="Edit Agreement"
      actions={[
        <DeleteButton
          onDelete={api.destroyAgreement}
          id={id}
          name="Agreement"
          redirectTo="/agreements"
          confirmationMessage="Deleting the agreement would unlink all linked opportunities. Are you sure you want to continue?"
        />,
        <Link to="show" className="btn btn-secondary ml-2">
          Show
        </Link>,
      ]}
      sticky
    >
      <UpdateAgreementForm id={id} />
    </Titled>
  );
};

UpdateAgreement.propTypes = {
  match: shape({ params: shape({ id: string.isRequired }).isRequired })
    .isRequired,
};

export default UpdateAgreement;
